import { Location } from '@angular/common';
import { OnInit } from '@angular/core';
import { QuestionSetLabel } from '../../shared/models/question-set-label';
import { AssessmentService } from '../../shared/services/assessment.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from 'app/shared/services/alert.service';
var LabelEditComponent = /** @class */ (function () {
    function LabelEditComponent(assessmentService, alertService, location, router, route) {
        this.assessmentService = assessmentService;
        this.alertService = alertService;
        this.location = location;
        this.router = router;
        this.route = route;
        this.label = this.getNewObject();
    }
    LabelEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            var assessmentUid = params['uid'];
            var setId = params['setId'];
            var labelId = params['labelId'];
            _this.assessmentService.getAssessment(assessmentUid)
                .then(function (assessment) {
                _this.assessment = assessment;
                _this.questionSet = assessment.question_sets.find(function (s) { return s.id == setId; });
                _this.label = (_this.questionSet) ? _this.questionSet.labels.find(function (l) { return l.id == labelId; }) : null;
                console.log(_this.label);
                if (!(_this.questionSet && _this.label)) {
                    // TODO: stephen should we navigate back?? or do some kind of 404?
                    _this.router.navigate(["not-found"]);
                }
            })
                .catch(function (error) {
                console.error(error);
                _this.router.navigate(["not-found"]);
            });
        });
    };
    LabelEditComponent.prototype.getNewObject = function () {
        var label = new QuestionSetLabel();
        return label;
    };
    Object.defineProperty(LabelEditComponent.prototype, "label", {
        get: function () {
            return this._label;
        },
        set: function (v) {
            this._label = v;
        },
        enumerable: true,
        configurable: true
    });
    LabelEditComponent.prototype.goBack = function () {
        this.location.back();
    };
    LabelEditComponent.prototype.saveLabel = function (label) {
        var _this = this;
        this.isSaving = true;
        return this.assessmentService.saveAssessment(this.assessment).then(function (assessment) {
            _this.alertService.success("Label saved");
            _this.isSaving = false;
            return label;
        }).catch(function (error) {
            _this.isSaving = false;
            _this.alertService.error("An error occurred in saving. Please try again or contact support.");
            console.error(error);
        });
    };
    LabelEditComponent.prototype.save = function () {
        this.saveLabel(this.label);
    };
    LabelEditComponent.prototype.saveAndCreateNew = function () {
        var _this = this;
        this.saveLabel(this.label).then(function (question) {
            _this.router.navigate(["../../", "new"], { replaceUrl: true, relativeTo: _this.route });
        });
    };
    return LabelEditComponent;
}());
export { LabelEditComponent };



// WEBPACK FOOTER //
// ./src/app/admin/label-edit/label-edit.component.ts.pre-build-optimizer.js